export enum CinemaPartnerType {
    BAR = 'bar',
    RESTAURANT = 'restaurant',
    PARKING = 'parking',
    MISCELLANEOUS = 'miscellaneous'
}
